module.exports = __webpack_public_path__ + "media/luxury-2026/estate-pool-960-131d0487.jpg";